import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomThickMinus({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M17.579 10.5H2.42C2.19 10.5 2 10.276 2 10s.189-.5.421-.5H17.58c.232 0 .421.224.421.5s-.189.5-.421.5z"
        fill="currentColor"
        fillRule="nonzero"
        stroke="currentColor"
        strokeWidth={0.75}
      />
    </svg>
  );
}
export default SvgIconCustomThickMinus;
